import keyboard from '../utils/keyboard';
import getScrollbarWidth from '../utils/getScrollbarWidth';
import $ from '../utils/jquery';
const $modals = $( '.modal' );
const $toggle = $( '[data-toggle="modal"]' );

const getFirstFocusElement = $modal => {
	return $modal.find( 'a, button, input' ).first();
};

const getLastFocusElement = $modal => {
	return $modal.find( 'a, button, input' ).last();
};

const showBackdrop = cb => {
	let calledCb = false;
	const $backdrop = $( '<div class="modal-backdrop"></div>' );

	// Prevent scroll and shift from removing scrollbar
	// Add backdrop
	$( 'body' )
		.css( {
			overflow: 'hidden',
			paddingRight: getScrollbarWidth()
		} )
		.append( $backdrop );

	// Animate backdrop in
	// Call callback halfway through
	$backdrop.animate( {
		opacity: 0.5
	}, {
		duration: 300,
		progress: ( animation, progress ) => {
			if ( progress > 0.5 && ! calledCb ) {
				calledCb = true;
				cb();
			}
		}
	} );
};

const showModal = $modal => {
	const $firstFocusElement = getFirstFocusElement( $modal );
	const $lastFocusElement = getLastFocusElement( $modal );

	$( 'body' ).addClass( 'modal-shown' );

	$modal.css( { display: 'block' } );

	window.setTimeout( () => {
		$modal
			.addClass( 'show' )
			.trigger( 'modal.shown' )
			.removeAttr( 'aria-hidden' )
			.attr( 'aria-modal', 'true' )
			.attr( 'role', 'dialog' );

		// Add focus to first element
		$firstFocusElement.get( 0 ).focus();

		// Tab back to last element if on first element
		$firstFocusElement.on( 'keydown', e => {
			if ( ( e.keyCode === keyboard.tab && e.shiftKey ) ) {
				e.preventDefault();
				$lastFocusElement.get( 0 ).focus();
			}
		} );

		// Tab to first element if on last element
		$lastFocusElement.on( 'keydown', e => {
			if ( ( e.keyCode === keyboard.tab && ! e.shiftKey ) ) {
				e.preventDefault();
				$firstFocusElement.get( 0 ).focus();
			}
		} );

		// Add close btn events
		$modal
			.find( '[data-dismiss="modal"]' )
			.each( ( i, el ) => {
				$( el ).on( 'click', () => {
					hide( $modal );
				} );
			} );

		// Close modal on background click
		$modal.on( 'click', e => {
			const $target = $( e.target );
			if ( $target.hasClass( 'modal' ) ) {
				hide( $target );
			}
		} );
	}, 150 );
};

const show = $modal => {
	if ( ! $modal.length ) {
		return;
	}

	$modal.trigger( 'modal.show' );

	showBackdrop( () => {
		showModal( $modal );
		$modal.trigger( 'modal.shown' );
	} );
};

const hideBackdrop = cb => {
	const $backdrop = $( '.modal-backdrop' );

	$backdrop
		.animate( {
			opacity: 0
		}, 300, () => {
			$backdrop.remove();
			$( 'body' )
				.css( {
					overflow: '',
					paddingRight: ''
				} );
			cb();
		} );
};

const hideModal = $modal => {
	const $firstFocusElement = getFirstFocusElement( $modal );
	const $lastFocusElement = getLastFocusElement( $modal );

	$( 'body' ).removeClass( 'modal-shown' );

	$modal
		.css( { display: 'none' } )
		.trigger( 'modal.hidden' )
		.attr( 'aria-hidden', 'true' )
		.removeAttr( 'aria-modal' )
		.removeAttr( 'role' );

	$firstFocusElement.off();
	$lastFocusElement.off();

	$modal
		.find( '[data-dismiss="modal"]' )
		.each( ( i, el ) => {
			$( el ).off();
		} );

	$modal.off();
};

const hide = $modal => {
	$modal.trigger( 'modal.hide' );

	$modal.removeClass( 'show' );

	hideBackdrop( () => {
		hideModal( $modal );
		$modal.trigger( 'modal.hidden' );
	} );
};

const bind = () => {
	// Use event delegation to handle dynamically added toggle buttons
	$( document ).on( 'click', '[data-toggle="modal"]', e => {
		const $btn = $( e.currentTarget );
		const $modal = $( $btn.attr( 'data-target' ) );
		show( $modal );
	} );

	// Use esc button to close modal
	$( document ).keyup( e => {
		if ( $( 'body' ).hasClass( 'modal-shown' ) && e.keyCode === keyboard.escape ) {
			hide( $( '.modal.show' ) );
		}
	} );
};

export default () => {
	if ( ! $modals.length ) {
		return;
	}

	bind();
};
